export const isMobileQuery = '991px';
